<template>
  <div>
    <div class="card border-0 shadow-sm" style="border-radius: 14px; background: #ffffff; border: 1.5px solid #e2e8f0 !important; box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);">
      <!-- Standard Vertex Header -->
      <div class="card-header bg-white border-0 pt-3 pb-2 px-3 d-flex justify-content-between align-items-start align-items-sm-center flex-wrap gap-2" style="border-bottom: 1px solid #f1f5f9 !important;">
        <div class="d-flex align-items-center gap-2">
          <div class="widget-icon-pill" style="background-color: #ffe4e6; color: #e11d48; width: 34px; height: 34px; border-radius: 9px; display: flex; align-items: center; justify-content: center; font-size: 0.95rem; flex-shrink: 0;">
            <i class="fas fa-user-clock"></i>
          </div>
          <div>
            <h6 class="mb-0 fw-bold" style="color: #1e293b; font-size: 0.875rem;">Overdue Training</h6>
            <small class="text-muted" style="color: #64748b; font-size: 0.72rem;">Employees with delayed modules</small>
          </div>
        </div>
        <div class="widget-controls d-flex align-items-center gap-2">
          <label class="mandatory-toggle-container m-0" v-tooltip.top="'Filter overdue training by mandatory programs only'">
            <input
              class="mandatory-toggle-input"
              type="checkbox"
              role="switch"
              id="mandatorySwitchOverdue"
              v-model="mandatoryOnly"
              @change="onMandatoryChange"
            />
            <span class="mandatory-toggle-track">
              <span class="mandatory-toggle-thumb"></span>
            </span>
            <span class="ms-2 mandatory-toggle-label">
              Mandatory
            </span>
          </label>
        </div>
      </div>

      <div class="card-body p-3">
        <div class="row">
          <div class="col text-center mx-auto" v-if="loading">
            <img src="@/assets/img/loading.svg" class="d-none d-sm-inline mx-auto" alt="">
            <img src="@/assets/img/loading-mobile.svg" class="d-inline d-sm-none mb-3" alt="">
          </div>
          <div class="table-responsive" v-else>
            <table class="table overdue-table mb-0" style="table-layout: fixed; width: 100%;">
              <thead>
                <tr class="overdue-table-header">
                  <th scope="col" style="width: 36%;">First Name</th>
                  <th scope="col" style="width: 36%;">Last Name</th>
                  <th scope="col" style="width: 28%;" class="text-end"># of Training Videos</th>
                </tr>
              </thead>
              <tbody v-if="!overdueTrainings || overdueTrainings.length === 0">
                <tr>
                  <td colspan="3" class="text-center text-muted py-4">No overdue training found.</td>
                </tr>
              </tbody>
              <tbody class="align-middle" v-for="(item, index) in overdueTrainings" :key="index" v-else>
                <tr class="overdue-row" style="cursor:pointer;" @click="navItemCollapse(index)" data-bs-toggle="collapse" :data-bs-target="'#overdue' + index" :aria-expanded="item.expand" aria-controls="overdue" v-tooltip.top="'Click to see overdue training details'">
                  <td class="fw-semibold text-slate text-truncate" :title="item.overdue_videos && item.overdue_videos.user ? item.overdue_videos.user.first_name : ''">
                    {{ item.overdue_videos && item.overdue_videos.user ? item.overdue_videos.user.first_name : '' }}
                  </td>
                  <td class="text-slate text-truncate" :title="item.overdue_videos && item.overdue_videos.user ? item.overdue_videos.user.last_name : ''">
                    {{ item.overdue_videos && item.overdue_videos.user ? item.overdue_videos.user.last_name : '' }}
                  </td>
                  <td class="text-end">
                    <span class="badge-overdue-count">
                      {{ item.overdue_videos ? item.overdue_videos.count : 0 }}
                    </span>
                  </td>
                </tr>
                <tr class="collapse collapse-vertical" :class="{show: item.expand}" style="transition: opacity ease-in-out;">
                  <td colspan="3" class="p-0 border-0">
                    <div class="p-2 bg-slate-subtle rounded-3 my-1">
                      <table class="table table-sm expand mb-0">
                        <thead>
                          <tr class="overdue-table-header">
                            <th>Name</th>
                            <th>Assigned Date</th>
                          </tr>
                        </thead>
                        <tbody v-if="!loading">
                          <tr v-for="(video, vIndex) in (item.training_videos || [])" :key="vIndex" class="sub-row">
                            <td id="align-left" class="text-slate">
                              {{ video.name }}
                            </td>
                            <td style="width: 30%; text-align:left;" class="text-muted small">
                              {{ localFormat(video.CreatedAt) }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="mt-3 pt-3 border-top d-flex align-items-center justify-content-between" style="border-color: #f1f5f9 !important;">
          <button
            :disabled="downloading"
            type="button"
            class="btn-download-pill"
            v-tooltip.top="'Download Overdue Training Report (.xlsx)'"
            @click="downloadOverdue"
          >
            <div v-if="downloading" class="spinner-border text-primary me-1" role="status" style="height: 12px; width: 12px;">
              <span class="visually-hidden">Loading...</span>
            </div>
            <svg v-if="!downloading" class="download-icon" width="13" height="13" viewBox="0 0 16 16" fill="currentColor">
              <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
              <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
            </svg>
            <span class="download-text">Download</span>
          </button>

          <div class="d-flex align-items-center">
            <a
              @click="prev"
              class="pagination-arrow"
              :class="{ disabled: isPrevDisabled }"
              :disabled="isPrevDisabled"
            >
              <i class="fa fa-chevron-left" aria-hidden="true"></i>
            </a>

            <span class="pagination-label mx-2">
              {{ paginationLabel }} of {{ pagination.total }}
            </span>

            <a
              @click="next"
              class="pagination-arrow"
              :class="{ disabled: isNextDisabled }"
              :disabled="isNextDisabled"
            >
              <i class="fa fa-chevron-right" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

 <script>
import * as XLSX from 'xlsx';
import moment from 'moment';

  export default {
    name: 'Dashboard',
    props: ['organisationID', 'isManager', 'showProduct'],

      data() {
        return {
          loading: false,
          downloading: false,
          overdueTrainings: [],
          quizResults: [],
          mandatoryOnly: false,
          pagination: {
            rowsPerPage: 5,
            page: 1,
            total: 2,
            manager: this.isManager
          },
          expandedData: [],
          expandedIndex: -1,
      }
    },

    async created() {
      if (!this.showProduct) return

      await this.init()
    },

    methods: {
      async init(){
        this.overdueTrainings = [];
        this.quizResults = [];
        this.loading = true;

        // await this.getQuiz()
        this.getData()
      },

      onMandatoryChange() {
        this.loading = true;
        if (this.pagination.page !== 1) {
          this.pagination.page = 1;
        } else {
          this.getData();
        }
      },

      getData(){
        let params = {
          limit: this.pagination.rowsPerPage,
          page: this.pagination.page,
          manager: this.pagination.manager,
          mandatory: this.mandatoryOnly,
        }

        return new Promise((resolve, reject) => {
        this.$axios.get("/orgadmin/trainings/user/organisations/"+this.organisationID + "/overdue", {params})
        .then(response => {
          if (response.data.success) {
            this.pagination.total = response.data.total
            this.overdueTrainings = response.data.overdue_videos
 
            if (!this.overdueTrainings) {
              this.loading = false
              return
            }

            for (let i = 0; i < this.overdueTrainings.length; i++) {
              this.overdueTrainings[i]["expand"] = false
            }

            this.loading = false
            resolve()
          }
        }).catch(error => {
            reject(error)
          })
        })
     },


    setExpandData(item) {
      this.expandedData = item
    },

    getQuiz(){
      return new Promise((resolve, reject) => {
      this.$axios.get("/trainings/organisations/"+ this.organisationID +"/answers")
      .then(response => {
        if (response.data.success) {
          this.quizResults = response.data.quiz_results;
          resolve()
        }
      }).catch(error => {
          reject(error)
        })
      })
    },

    inArray(array, id) {
      return id in array ? array[id] : null;
    },

    prev(){
      if (!this.isPrevDisabled) {
        this.pagination.page -= 1;
      }
    },

    next() {
      if (!this.isNextDisabled) {
        this.pagination.page += 1;
      }
    },

    localFormat(date){
      return moment(date).format("LL")
    },

    navItemCollapse(index) {
      this.overdueTrainings = this.overdueTrainings.map((item, i) => {
        if (i === index) {
          item.expand = !item.expand
          if (item.expand) {
            this.expandedData = item.training_videos || []
          }
        } else {
          item.expand = false
        }
        return item
      })
    },

    sanitizeSpreadsheetCell(val) {
      if (typeof val !== 'string') return val ?? ''
      if (/^[=+\-@\t\r]/.test(val)) {
        return `'${val}`
      }
      return val
    },

    async downloadOverdue() {
      if (this.downloading) return;
      this.downloading = true;
      try {
        let params = {
          limit: 1000,
          page: 1,
          manager: this.pagination.manager,
          mandatory: this.mandatoryOnly,
        };
        const res = await this.$axios.get("/orgadmin/trainings/user/organisations/" + this.organisationID + "/overdue", { params });
        let list = (res.data && res.data.overdue_videos) ? res.data.overdue_videos : this.overdueTrainings;
        let rows = [["First Name", "Last Name", "# of Overdue Training Videos", "Overdue Modules"]];
        for (const item of (list || [])) {
          const fn = item.overdue_videos && item.overdue_videos.user ? item.overdue_videos.user.first_name : '';
          const ln = item.overdue_videos && item.overdue_videos.user ? item.overdue_videos.user.last_name : '';
          const count = item.overdue_videos ? item.overdue_videos.count : 0;
          const vNames = (item.training_videos || []).map(v => v.name).join("; ");
          rows.push([
            this.sanitizeSpreadsheetCell(fn),
            this.sanitizeSpreadsheetCell(ln),
            count,
            this.sanitizeSpreadsheetCell(vNames)
          ]);
        }
        const ws = XLSX.utils.aoa_to_sheet(rows);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Overdue Training");
        const dateToday = moment().format("YYYYMMDD");
        XLSX.writeFile(wb, `${dateToday}_overdue_training_report.xlsx`);
      } catch (err) {
        console.error("Failed to download overdue report", err);
      } finally {
        this.downloading = false;
      }
    },

  },

  computed: {
    currPage(){
      return this.pagination.page
    },

    isPrevDisabled() {
      return this.pagination.page <= 1
    },

    isNextDisabled() {
      if (!this.overdueTrainings || this.overdueTrainings.length === 0) {
        return true
      }
      if (this.pagination.page * this.pagination.rowsPerPage >= this.pagination.total) {
        return true
      }
      return this.overdueTrainings.length < this.pagination.rowsPerPage
    },

    paginationLabel() {
      if (!this.pagination.total || this.pagination.total === 0) {
        return "0 - 0"
      }
      var start = (this.pagination.page - 1) * this.pagination.rowsPerPage + 1
      var end = Math.min((this.pagination.page * this.pagination.rowsPerPage), this.pagination.total)

      return start + " - " + end
    }
  },

  watch: {
    currPage() {
      this.init()
    }
  }

  }

 </script>
 <style scoped>
.widget-icon-pill {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.text-slate {
  color: #1e293b;
  font-size: 0.8125rem;
}

.overdue-table {
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
}

.overdue-table-header th {
  font-size: 0.75rem;
  font-weight: 700;
  color: #435666;
  background-color: #F4F6F8 !important;
  border-bottom: 1.5px solid #e2e8f0;
  padding: 8px 10px;
}

.overdue-row td {
  padding: 10px;
  border-bottom: 1px solid #f1f5f9;
  transition: background-color 0.15s ease;
}

.overdue-row:hover td {
  background-color: #f8fafc;
}

.sub-row td {
  padding: 6px 10px;
  border-bottom: 1px solid #e2e8f0;
}

.bg-slate-subtle {
  background-color: #f8fafc;
  border: 1px solid #f1f5f9;
}

.badge-overdue-count {
  display: inline-block;
  background-color: #ffe4e6;
  color: #e11d48;
  font-weight: 700;
  font-size: 0.75rem;
  padding: 2px 8px;
  border-radius: 9999px;
  min-width: 24px;
  text-align: center;
}

.border-top-subtle {
  border-top: 1px solid #f1f5f9;
}

/* Custom Compact Mandatory Toggle with White Background */
.mandatory-toggle-container {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  margin: 0;
}

.mandatory-toggle-input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  margin: 0;
  pointer-events: none;
}

.mandatory-toggle-track {
  position: relative;
  display: inline-block;
  width: 32px;
  height: 18px;
  background-color: #cbd5e1;
  border-radius: 18px;
  transition: background-color 0.25s ease, box-shadow 0.25s ease;
  flex-shrink: 0;
}

.mandatory-toggle-thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 14px;
  height: 14px;
  background-color: #ffffff;
  border-radius: 50%;
  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.mandatory-toggle-input:checked + .mandatory-toggle-track {
  background-color: #00a0c1;
}

.mandatory-toggle-input:checked + .mandatory-toggle-track .mandatory-toggle-thumb {
  transform: translateX(14px);
  background-color: #ffffff;
}

.mandatory-toggle-container:hover .mandatory-toggle-track {
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
}

.mandatory-toggle-label {
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}

.pagination-arrow {
  font-size: 13px;
  color: #00a0c1;
  cursor: pointer;
  user-select: none;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  transition: background-color 0.15s ease;
}

.pagination-arrow:hover:not(.disabled) {
  background-color: #e0f7fa;
}

.pagination-arrow.disabled {
  color: #cbd5e1 !important;
  cursor: not-allowed;
  pointer-events: none;
}

.pagination-label {
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
  user-select: none;
}

/* Figma Pill Download Button */
.btn-download-pill {
  background-color: #ffffff;
  color: #00a0c1;
  border: 1.5px solid #00a0c1;
  border-radius: 20px;
  padding: 4px 14px;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.2;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}

.btn-download-pill:hover:not(:disabled) {
  background-color: #00a0c1;
  color: #ffffff;
  border-color: #00a0c1;
  box-shadow: 0 2px 6px rgba(0, 160, 193, 0.35);
}

.btn-download-pill:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-download-pill .download-icon {
  margin-right: 6px;
  flex-shrink: 0;
}

.btn-download-pill .download-text {
  font-weight: 700;
  font-size: 13px;
}
 </style>
